import StoreCashTile from '../components/StoreCashTile'
import './Carousel.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import useWidgetWidth from '../hooks/useWidgetWidth';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';


function StoreCashSlider({tilesData}) {
    const tilesDataArr = Object.entries(tilesData)
    tilesDataArr.sort((a, b) => b[1].Priority - a[1].Priority)
    const widgetWidth = useWidgetWidth();
   
    
    const responsive = {
      allDevices: {
        breakpoint: { max: 4000, min: 280 },
        items: widgetWidth,
      },
    };
     
 return tilesDataArr.length > 1 ? (
  <Swiper
  slidesPerView={widgetWidth}
  breakpoints={responsive}
  navigation={true}
  modules={[Navigation]}
  className="storecashSwiper"
  >
    {tilesDataArr.map((tileData, i) => (
      <SwiperSlide key={i}><StoreCashTile  tileData={tileData} key={i} tilesNumber={tilesDataArr.length} position={i}/></SwiperSlide>
    ))}
  </Swiper>
) : (
  
  tilesDataArr && tilesDataArr !== undefined && tilesDataArr[0] !== undefined ? <StoreCashTile tilesNumber={tilesDataArr.length} singleTtileData={tilesDataArr[0]}/> : null
);
}

export default StoreCashSlider
